import { makeAutoObservable } from "mobx";

export default class CouponStore {

    constructor() {
        makeAutoObservable(this)
    }
}